import { liveEventDebug } from '.'

const wait = (ms: number) =>
    new Promise<void>((resolve) => setTimeout(resolve, ms))

export const scrollToElement = async (
    idOrElement: string | HTMLElement | undefined | null,
    waitMs = 0,
) => {
    if (!idOrElement) {
        return
    }

    let element

    if (typeof idOrElement === 'string') {
        element = document.getElementById(idOrElement)
    } else {
        element = idOrElement
    }

    liveEventDebug('Waiting to scroll: %s', waitMs)

    await wait(waitMs)

    if (element) {
        liveEventDebug('Element found, scrolling into view: %s', idOrElement)
        element.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
}
